<template>
  <!-- Kontener pojedynczego filtra: flexowy układ w wierszu -->
  <div class="filter d-flex">
    <!-- Etykieta filtra: wyświetla przekazaną nazwę bez tłumaczenia -->
    <div class="name">{{ name }}</div>
    <!-- Symbol operatora (np. '=', '>='), wyświetlany jeśli został przekazany jako props -->
    <span class="symbol">{{ symbol }}</span>
    <!-- Pole input wiązane dwukierunkowo z wartością filtra:
         - name odpowiada kluczowi w store.filters
         - v-model.lazy aktualizuje value po zdarzeniu 'change'
    -->
    <input
      :name="fieldName"
      v-model.lazy="value"
    />
  </div>
</template>

<script>
import { computed } from "vue";
import { useCurrentFiltersStore } from "../../stores/currentFilters";
import { isNOSG } from "@/config/appVersion";

export default {
  name: "SingleFilter",
  props: ["name", "symbol", "fieldName"],

  setup(props) {
    const filtersStore = useCurrentFiltersStore();

    if (
      props.fieldName === "similarity" &&
      isNOSG &&
      (filtersStore.filters[props.fieldName] === undefined || filtersStore.filters[props.fieldName] === "")
    ) {
      filtersStore.addItem(props.fieldName, 1);
    }

    // v-model podpięty bezpośrednio do store — zapis jest synchroniczny.
    // Patrz komentarz w RangeFilter.vue: wcześniejsza implementacja z `ref` + `watch`
    // powodowała race condition z watcherem na current.step (pierwsze żądanie
    // w kroku 3 szło bez świeżo wprowadzonych filtrów).
    const value = computed({
      get: () => filtersStore.filters[props.fieldName] ?? "",
      set: (val) => filtersStore.addItem(props.fieldName, val),
    });

    return { value, filtersStore };
  },
};
</script>

<style scoped>
/* Styl całego kontenera filtra: dolna granica i padding */
.filter {
  border-bottom: 1px solid #b7b7b5;
  padding-bottom: 5px;
}

/* Styl symbolu operatora: padding i stała szerokość */
.symbol {
  padding: 5px 9px 5px 8px; /* padding: góra, prawo, dół, lewo */
  width: 24px;
  margin-right: 1px;
}

/* Styl pola input: szerokość, padding, wyśrodkowanie tekstu i uppercase */
input {
  width: 124px;
  padding: 2px 10px;
  text-align: center;
  text-transform: uppercase;
}
</style>
